import { Link, Stack, Typography, useMediaQuery } from '@mui/material'
import { TProductDelivery } from '../../../../core/types/Product'

interface ITypePaymentChoose {
  onChange: (value: TProductDelivery) => void
}

const items = [
  {
    type: TProductDelivery.Course,
    label: 'Curso online',
    image: '/assets/products/course.svg',
  },
  {
    type: TProductDelivery.eBook,
    label: 'Ebook',
    image: '/assets/products/ebook.svg',
  },
  {
    type: TProductDelivery.Ticket,
    label: 'Ingresso',
    image: '/assets/products/ticket.svg',
  },
  {
    type: TProductDelivery.Community,
    label: 'Comunidade',
    image: '/assets/products/community.svg',
  },
]

const TypeDeliveryChooseMobile = ({ onChange }: ITypePaymentChoose) => (
  <Stack direction="column" spacing={2} sx={{ gap: '16px' }}>
    {items.map(({ type, label, image }) => (
      <Link
        key={type}
        onClick={() => onChange(type)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          border: '1px solid rgba(220, 221, 222, 1)',
          borderRadius: '8px',
          width: '100%',
          padding: '16px',
          textDecoration: 'none',
        }}
      >
        <img
          alt={label}
          src={image}
          style={{ width: '80.12px', height: '80px', marginRight: '16px' }}
        />
        <Typography
          sx={{
            fontFamily: 'Montserrat',
            fontWeight: 700,
            fontSize: '16px',
            lineHeight: '20px',
            color: 'rgba(52, 57, 72, 1)',
          }}
        >
          {label}
        </Typography>
      </Link>
    ))}
  </Stack>
)

const TypeDeliveryChoose = ({ onChange }: ITypePaymentChoose) => {
  const isSmallScreen = useMediaQuery((theme: any) =>
    theme.breakpoints.down('md')
  )

  if (isSmallScreen) {
    return <TypeDeliveryChooseMobile onChange={onChange} />
  }

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        justifyContent: 'center',
        height: '286px',
        gap: '16px',
      }}
    >
      {items.map(({ type, label, image }) => (
        <Link
          key={type}
          onClick={() => onChange(type)}
          sx={{
            border: '1px solid rgba(220, 221, 222, 1)',
            borderRadius: '8px',
            width: '240px',
            height: '286px',
            padding: '24px',
            gap: '32px',
            textDecoration: 'none',
            cursor: 'pointer',
          }}
        >
          <Stack
            direction="column"
            spacing={1}
            alignContent="center"
            alignItems="center"
            sx={{ p: 2 }}
          >
            <img
              alt={label}
              src={image}
              style={{ width: '100%', height: '200px' }}
            />

            <Typography
              sx={{
                fontFamily: 'Montserrat',
                fontWeight: 700,
                fontSize: '16px',
                lineHeight: '20px',
                color: 'rgba(52, 57, 72, 1)',
              }}
            >
              {label}
            </Typography>
          </Stack>
        </Link>
      ))}
    </Stack>
  )
}

export default TypeDeliveryChoose
